import { Instance, types } from 'mobx-state-tree';

const ErrorsStore = types.model({
  fetchingAccountsPayableLink: types.optional(types.boolean, false),
});

export interface TErrorsStore extends Instance<typeof ErrorsStore> {}
export default ErrorsStore;
